import React from "react";
import RiskAssessment from "./RiskAssessment";
import "../styles/Assessment.css";

function Assessment() {
  return (
    <div className="assessment-container">
      <h1>Risk Assessment</h1>
      <p>Use this tool to evaluate your concussion risk and cognitive function.</p>

      <div className="assessment-sections">
        <RiskAssessment />
      </div>
    </div>
  );
}

export default Assessment;